import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/mining";

/** Mining page — mining.bizlem.com */
export default function MiningPage() {
  return <SubdomainSite config={config} />;
}

export { config };
